import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Menu } from '../../interfaces/Menu/Menu';
import { deleteMenu, getMenus } from '../../api/Menu';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { MenusTable } from './MenusTable';
import { UpsertMenuDialog } from './UpsertMenuDialog';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';

export const MenusPage = () => {
  const [menuToDelete, setMenuToDelete] = useState<Menu | undefined>(undefined);
  const [showInsertDialog, setShowInsertDialog] = useState(false);
  const [clickedMenu, setClickedMenu] = useState<Menu | undefined>(undefined);
  const [menus, setMenus] = useState<Menu[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshMenus = () => {
    setLoading(true);
    getMenus()
      .then((m) => setMenus(m))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshMenus();
  }, []);

  const handleCloseDialog = () => {
    setShowInsertDialog(false);
    setClickedMenu(undefined);
  };

  const handleDelete = () => {
    if (!menuToDelete) {
      return;
    }

    setLoading(true);
    deleteMenu(menuToDelete.id)
      .then(() => {
        toast.success('Menü başarıyla silindi');
        refreshMenus();
        setMenuToDelete(undefined);
      })
      .catch((err) => toast.error(err.message));
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <ConfirmDialog
        content='Gerçekten seçili menüyü silmek istiyor musunuz'
        open={!!menuToDelete}
        onClose={() => setMenuToDelete(undefined)}
        onConfirm={handleDelete}
        color='error'
      />
      <UpsertMenuDialog
        open={showInsertDialog || !!clickedMenu}
        clickedMenu={clickedMenu}
        onUpsert={() => {
          handleCloseDialog();
          refreshMenus();
        }}
        onClose={handleCloseDialog}
      />
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Menüler
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => setShowInsertDialog(true)}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Menü
      </Button>
      <MenusTable
        menus={menus}
        onClickRow={(row) => setClickedMenu(row)}
        onDeleteRow={(row) => setMenuToDelete(row)}
      />
    </Box>
  );
};
